import React from 'react';
import PropTypes from 'prop-types';

import SidebarFilter from './SidebarFilter';

const Sidebar = ({ filters, pins, onPinSelect, isDesktop }) => {
  const handlePinSelect = (e, pin) => {
    if (!isDesktop) return;
    e.preventDefault();
    onPinSelect(pin);
  };

  return (
    <div className="interactive-map-module__sidebar-filters">
      {filters.map(filter => (
        <SidebarFilter
          key={filter.filterId}
          filter={filter}
          pins={pins.filter(pin => pin.filterId === filter.filterId)}
          onPinSelect={handlePinSelect}
        />
      ))}
    </div>
  );
};

Sidebar.propTypes = {
  filters: PropTypes.array.isRequired,
  pins: PropTypes.array.isRequired,
  onPinSelect: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired
};

export default Sidebar;
